module.exports = __webpack_public_path__ + "static/media/communication.f1e5a05d.svg";